import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGING_NETWORKS } from "../../../API/UserApi";

import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const deleteNetworksAPI: any = createAsyncThunk(
  "deleteNetworks",
  async (rowId: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.delete(CHARGING_NETWORKS + "/" + rowId, {
        headers: commonHead,
      });
      ;
      return { networkDeleted: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
